<template>
    <a-card>
        <!-- <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="活动名称" name="activityName">
                <a-input v-model:value="searchForm.activityName" placeholder="请输入活动名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form> -->
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #activityName="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">{{record.activityName}}</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <Detail ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import Detail from "./components/Detail";
import {tableListMixin} from "@/mixins";
import {basicsActivityApply,basicsActivityInfo} from "@/api/tenantService";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "活动名称", dataIndex: "activityName", key: "activityName", slots: {customRender: "activityName"}},
    {title: "报名时间", dataIndex: "createdTime", key: "createdTime", customRender: defaultDateCustomRender},
    {title: "企业名称", dataIndex: "unitName", key: "unitName"},
    {title: "联系人", dataIndex: "name", key: "name"},
    {title: "联系电话", dataIndex: "phone", key: "phone"},
    {title: "预计报名人数", dataIndex: "applyNum", key: "applyNum"},
];
export default {
    name: "信息补充",
    mixins: [tableListMixin],
    components: {
    Detail,
},
    data() {
        return {
            dictNames: 'isPublic,serviceStatus,condition,demand_type',
            columns,
            queryParam: {},
            listUrl: basicsActivityApply.pageList,
            listKeyField: "id",
            // deleteUrl: basicsActivityApply.remove
        }
    },
    methods: {
        onEdit(record) {
            console.log(record)
            this.getAction({
                url: basicsActivityInfo.detail,
                params: {id: record.activityId}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
